import { Box, Card, CardActionArea, CardContent, Grid } from '@mui/material';
import { Body } from 'components/Typography';
import { useTranslation } from 'react-i18next';
import { LogoSpin, OpsEnfantSoleilLogo, RedemptionIcon } from '../../../assets/icons';
import { ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'common/hooks/useNavigate';
import config from '../../../config';

interface Box {
  icon: JSX.Element;
  label: string;
  pathFr: string;
  pathEn: string;
}

type Boxes = Box[];

export default function StaticBanner(): JSX.Element {
  const { t, i18n } = useTranslation('familiplusPage');
  const navigate = useNavigate();
  const localize = (key: string, obj?: Record<string, string>) => t(`staticBanner.${key}`, obj ?? {});

  const boxes: Boxes = [
    {
      icon: <OpsEnfantSoleilLogo width="64px" height={'64px'} />,
      label: 'donation',
      pathFr: `/fr/Compte/Familiplus/OES`,
      pathEn: `/en/Account/Familiplus/OES`,
    },
    {
      icon: <LogoSpin width="64px" height={'64px'} />,
      label: 'downloadApp',
      pathFr: 'https://www.familiprix.com/fr/app-familiprix',
      pathEn: 'https://www.familiprix.com/en/app-familiprix',
    },
    {
      icon: <RedemptionIcon width="64px" height={'64px'} />,
      label: 'discoverFamiliplus',
      pathFr: config.AVANTAGES_FAMILIPLUS_FR_URL,
      pathEn: config.AVANTAGES_FAMILIPLUS_EN_URL,
    },
  ];

  return (
    <Grid mt={0} id="StaticBanner" spacing={2} container>
      {boxes.map((item: Box, index) => (
        <Grid data-cy="BoxItem" key={`BoxItem${index}`} item xs={12} md={4}>
          <Card data-cy="BoxItemCard" sx={{ borderRadius: '6px', color: '#002C53', fontSize: '12x' }} elevation={1}>
            <CardActionArea
              data-cy="BoxItemButton"
              sx={{ height: '160px' }}
              onClick={() =>
                item.pathFr.startsWith('/')
                  ? navigate(i18n.resolvedLanguage == 'fr' ? item.pathFr : item.pathEn)
                  : i18n.resolvedLanguage == 'fr'
                    ? window.open(item.pathFr, '_blank')
                    : window.open(item.pathEn, '_blank')
              }>
              <CardContent
                data-cy="BoxItemContent"
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  padding: '16px',
                  gap: '16px',
                }}>
                {item.icon}
                <Grid direction="row" alignItems="flex-end" item xs container spacing={1}>
                  <Grid xs={10} item>
                    <Body>
                      <b>{localize(item.label)}</b>
                    </Body>
                  </Grid>
                  <Grid item xs>
                    <ArrowForwardIos sx={{ fontSize: 15, color: '#306CE1', float: 'right' }} />
                  </Grid>
                </Grid>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
